// extracted by mini-css-extract-plugin
module.exports = {"title":"Account_title__AspO0","description":"Account_description__q6zMB","beneficiary-container":"Account_beneficiary-container__1-Ku_","group":"Account_group__20zsw"};